import dayjs from 'dayjs';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logger } from '../logger/logger';
import type { State } from './financials-store.type';
import { Charts, ChartType, View } from './financials-store.type';

const useFinancialsStore = create<State>()(
  devtools(
    persist(
      logger((_set) => ({
        view: View.Charts,
        chart: Charts.CostVersusOutput,
        team: null,
        board: null,
        startDate: dayjs().subtract(3, 'month').toDate(),
        endDate: dayjs().toDate(),
        filters: {
          costVersusOutput: {
            selectedChartType: ChartType.Line,
            selectedMeasures: ['daily_burn', 'committed_tasks', 'completed_tasks', 'cost_per_task'],
            selectedTrendLines: [],
          },
          allocationOfCosts: {
            selectedChartType: ChartType.Bar,
            selectedMeasure: 'assignee',
            selectedOptions: [],
            selectedTrendLines: [],
          },
          costByInitiative: {
            selectedChartType: ChartType.Bar,
            selectedInitiativeIds: [],
            selectedTrendLines: [],
          },
        },
        table: {
          selectedYear: null,
          searchTerm: '',
        },
      })),
      {
        name: 'financials-store',
        storage: createJSONStorage(() => localStorage),
        version: 1,
      },
    ),
  ),
);

export { useFinancialsStore };
